import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, TransitionGroup as _TransitionGroup, unref as _unref, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "list list--bordered list--sm" };
const _hoisted_2 = { class: "line line--aic line--nowrap" };
const _hoisted_3 = { class: "line__item line__item--grow" };
const _hoisted_4 = {
    key: 0,
    class: "prod-line__cover"
};
const _hoisted_5 = { class: "prod-line__main" };
const _hoisted_6 = { class: "prod-line__info" };
const _hoisted_7 = { class: "prod-line__brand" };
const _hoisted_8 = { class: "prod-line__name" };
const _hoisted_9 = {
    key: 0,
    class: "prod-line__offer"
};
const _hoisted_10 = {
    key: 0,
    class: "prod-line__price"
};
const _hoisted_11 = { class: "prod-line__price-current" };
const _hoisted_12 = {
    key: 0,
    class: "prod-line__price-old"
};
const _hoisted_13 = {
    key: 0,
    class: "line__item"
};
import { computed, ref } from "vue";
import Button from "../../../components/Button.vue";
import Picture from "../../../components/Picture.vue";
import Price from "../../../components/Price.vue";
import { transitionHook } from "../../../utils";
export default /*@__PURE__*/ _defineComponent({
    __name: 'UserSetItemsList',
    props: {
        items: { type: Array, required: true },
        mode: { type: String, default: 'constructor' },
        showPrice: { type: Boolean, default: false },
        replacementMode: { type: Boolean, default: false },
        saving: { type: Boolean, default: false }
    },
    emits: ["replace", "remove"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const icon = computed(() => props.replacementMode ? 'refresh' : 'remove');
        const transitionName = ref('item-none');
        function onclick(index) {
            if (props.replacementMode) {
                transitionName.value = 'item-replace';
                emit('replace', index);
            }
            else {
                transitionName.value = 'item-delete';
                emit('remove', index);
            }
        }
        const beforeLeave = transitionHook((el) => {
            if (transitionName.value === 'item-delete') {
                el.style.setProperty('--el-height', `${el.scrollHeight}px`);
            }
            else if (transitionName.value === 'item-replace') {
                el.style.top = `${el.offsetTop}px`;
            }
        });
        const afterLeave = transitionHook((el) => {
            el.style.removeProperty('--el-height');
            el.style.top = '';
            transitionName.value = 'item-none';
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_TransitionGroup, {
                    name: transitionName.value,
                    css: transitionName.value !== 'item-none',
                    onBeforeLeave: _unref(beforeLeave),
                    onAfterLeave: _unref(afterLeave),
                    onLeaveCancelled: _unref(afterLeave)
                }, {
                    default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                                class: "list__item",
                                key: item.uid ?? index
                            }, [
                                _createElementVNode("div", _hoisted_2, [
                                    _createElementVNode("div", _hoisted_3, [
                                        _createElementVNode("div", {
                                            class: _normalizeClass(["prod-line prod-line--extra", { 'prod-line--inactive': !item.available }])
                                        }, [
                                            (item.image)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                                    _createVNode(Picture, {
                                                        picture: item.image,
                                                        fill: "",
                                                        lazy: false
                                                    }, null, 8 /* PROPS */, ["picture"])
                                                ]))
                                                : _createCommentVNode("v-if", true),
                                            _cache[4] || (_cache[4] = _createTextVNode()),
                                            _createElementVNode("div", _hoisted_5, [
                                                _createElementVNode("div", _hoisted_6, [
                                                    _createElementVNode("div", _hoisted_7, _toDisplayString(item.brandName), 1 /* TEXT */),
                                                    _cache[0] || (_cache[0] = _createTextVNode()),
                                                    _createElementVNode("div", _hoisted_8, _toDisplayString(item.name) + _toDisplayString(item.offerName ? ',' : ''), 1 /* TEXT */),
                                                    _cache[1] || (_cache[1] = _createTextVNode()),
                                                    (item.offerName)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(item.offerName), 1 /* TEXT */))
                                                        : _createCommentVNode("v-if", true)
                                                ]),
                                                _cache[3] || (_cache[3] = _createTextVNode()),
                                                (__props.showPrice && item.price)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                                        _createElementVNode("span", _hoisted_11, [
                                                            _createVNode(Price, {
                                                                amount: item.price,
                                                                long: "",
                                                                "fixed-width": ""
                                                            }, null, 8 /* PROPS */, ["amount"])
                                                        ]),
                                                        _cache[2] || (_cache[2] = _createTextVNode()),
                                                        (item.basePrice && item.basePrice !== item.price)
                                                            ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                                                                _createVNode(Price, {
                                                                    amount: item.basePrice,
                                                                    long: "",
                                                                    "fixed-width": ""
                                                                }, null, 8 /* PROPS */, ["amount"])
                                                            ]))
                                                            : _createCommentVNode("v-if", true)
                                                    ]))
                                                    : _createCommentVNode("v-if", true)
                                            ])
                                        ], 2 /* CLASS */)
                                    ]),
                                    _cache[5] || (_cache[5] = _createTextVNode()),
                                    (__props.mode === 'constructor')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                            _createVNode(Button, {
                                                icon: icon.value,
                                                styling: "4",
                                                color: "gray",
                                                disabled: __props.saving,
                                                onClick: ($event) => (onclick(index))
                                            }, null, 8 /* PROPS */, ["icon", "disabled", "onClick"])
                                        ]))
                                        : _createCommentVNode("v-if", true)
                                ])
                            ]));
                        }), 128 /* KEYED_FRAGMENT */))
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["name", "css", "onBeforeLeave", "onAfterLeave", "onLeaveCancelled"])
            ]));
        };
    }
});
